import FJTextToFullVideoStart from './FJTextToFullVideoStart';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
const FJTextToFullVideoStartContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const freeNumCreationInfo = useSelector(state => state.textToVideo.freeNumCreationInfo);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const onGenerateScript = useCallback(() => {
        dispatch(FJActionTextToVideo.onTextToScriptAction());
    }, [dispatch]);
    const gotoPasteScript = useCallback(() => {
        dispatch(FJActionTextToVideo.gotoPasteScriptAction());
    }, [dispatch]);

    return (
        <FJTextToFullVideoStart
            onGenerateScript={onGenerateScript}
            gotoPasteScript={gotoPasteScript}
            creditNumber={creditNumber}
            freeTimes={freeNumCreationInfo.textToScript}
        />
    );
};

export default FJTextToFullVideoStartContainer;
